import axios from "axios";
import { ApiProvider } from "@src/store/ApiProvider";

const PASSWORD_MANAGER_ACCESS_TOKEN_KEY = "PasswordManager_accessToken";
const PASSWORD_MANAGER_REFRESH_TOKEN_KEY = "PasswordManager_refreshToken";

export const PASSWORD_MANAGER_AUTH_READY_EVENT = "password-manager-auth-ready";
export const PASSWORD_MANAGER_AUTH_CLEARED_EVENT = "password-manager-auth-cleared";

export const getPasswordManagerAccessToken = () => localStorage.getItem(PASSWORD_MANAGER_ACCESS_TOKEN_KEY) ?? "";

export const getPasswordManagerRefreshToken = () => localStorage.getItem(PASSWORD_MANAGER_REFRESH_TOKEN_KEY) ?? "";

export const setPasswordManagerAccessToken = (accessToken: string) => {
	if (!accessToken) return;
	localStorage.setItem(PASSWORD_MANAGER_ACCESS_TOKEN_KEY, accessToken);
	window.dispatchEvent(new CustomEvent(PASSWORD_MANAGER_AUTH_READY_EVENT, { detail: { accessToken } }));
};

export const setPasswordManagerAuthTokens = ({ accessToken, refreshToken }: { accessToken: string; refreshToken?: string }) => {
	if (!accessToken) return;
	localStorage.setItem(PASSWORD_MANAGER_ACCESS_TOKEN_KEY, accessToken);
	if (refreshToken) {
		localStorage.setItem(PASSWORD_MANAGER_REFRESH_TOKEN_KEY, refreshToken);
	}
	window.dispatchEvent(new CustomEvent(PASSWORD_MANAGER_AUTH_READY_EVENT, { detail: { accessToken } }));
};

export const clearPasswordManagerAuthTokens = () => {
	localStorage.removeItem(PASSWORD_MANAGER_ACCESS_TOKEN_KEY);
	localStorage.removeItem(PASSWORD_MANAGER_REFRESH_TOKEN_KEY);
	window.dispatchEvent(new Event(PASSWORD_MANAGER_AUTH_CLEARED_EVENT));
};

export const loginToPasswordManager = async ({ username, password }: { username: string; password: string }) => {
	const passwordManagerBaseURL = ApiProvider.default.passwordManagerBaseURL;
	if (!passwordManagerBaseURL) return null;

	const response = await axios.post<{
		token?: {
			accessToken?: string;
			refreshToken?: string;
		};
	}>(`${passwordManagerBaseURL}/Authentication/login`, {
		username,
		password,
	});

	const accessToken = response.data?.token?.accessToken ?? "";
	const refreshToken = response.data?.token?.refreshToken ?? "";

	if (!accessToken) return null;

	setPasswordManagerAuthTokens({ accessToken, refreshToken });
	return { accessToken, refreshToken };
};
